<template>
	<v-container grid-list-md style="max-width: 750px">
		<v-layout row wrap>
			<v-flex xs12>
				<h2>{{ $t("title.topup") }}</h2>
			</v-flex>
			<v-flex xs12>
				<v-alert
					dismissible
					color="secondary"
					border="left"
					elevation="2"
					colored-border
					icon="mdi-cash"
					v-if="item.hash"
				>
					<v-row align="center">
						<v-col class="grow">
							If you are already paid, please click verify button
							to continue.
						</v-col>
						<v-col class="shrink" @click="verifyPayment()">
							<v-btn :loading="$wait.is('verifying payment')">
								{{ $t("label.verify") }}
							</v-btn>
						</v-col>
					</v-row>
				</v-alert>
			</v-flex>
			<v-flex xs12>
				<ValidationObserver ref="obs" v-slot="{ invalid }">
					<v-card>
						<v-card-title primary-title>
							{{ coupon.name }}
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-layout row wrap>
								<v-flex xs12 v-html="coupon.description">
								</v-flex>
								<v-flex xs12>
									<WalletPaymentMethodForm
										v-model="item"
										:payment_methods="payment_methods"
										flat
									></WalletPaymentMethodForm>
								</v-flex>
							</v-layout>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<Link
								as="v-btn"
								text
								:href="$route('wallet.index')"
							>
								{{ $t("label.cancel") }}
							</Link>
							<v-btn
								color="primary"
								@click.native="submit()"
								:loading="item.processing"
								:disabled="invalid"
							>
								<v-icon left>mdi-wallet-plus-outline</v-icon>
								{{ $t("label.topup") }} {{ coupon.price }}
							</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</ValidationObserver>
			</v-flex>
		</v-layout>

		<v-dialog v-model="dialog" persistent max-width="800px" attach>
			<v-card>
				<v-alert
					prominent
					color="grey lighten-2"
					border="bottom"
					icon="mdi-cash"
				>
					<v-row align="center">
						<v-col class="grow">
							<div class="text-h6">
								{{ $t("title.payment_confirmation") }}
							</div>
							<div>
								{{
									$t(
										"message.payment_confirmation_dialog_description"
									)
								}}
							</div>
						</v-col>
						<v-col class="shrink">
							<v-btn @click="close()">
								<v-icon left>mdi-close</v-icon>
								{{ $t("Close") }}
							</v-btn>
						</v-col>
					</v-row>
				</v-alert>
				<v-card-text>
					<template v-if="payway">
						<v-form
							method="post"
							:action="payway.api_url"
							target="aba_webservice"
							id="aba_merchant_request"
							ref="form"
						>
							<input
								type="hidden"
								name="req_time"
								v-model="payway.req_time"
							/>
							<input
								type="hidden"
								name="merchant_id"
								v-model="payway.merchant_id"
							/>
							<input
								type="hidden"
								name="hash"
								v-model="payway.hash"
							/>
							<input
								type="hidden"
								name="tran_id"
								v-model="payway.tran_id"
							/>
							<input
								type="hidden"
								name="amount"
								v-model="payway.amount"
							/>
							<input
								type="hidden"
								name="items"
								v-model="payway.items"
							/>
							<input
								type="hidden"
								name="shipping"
								v-model="payway.shipping"
							/>
							<input
								type="hidden"
								name="firstname"
								v-model="payway.firstname"
							/>
							<input
								type="hidden"
								name="lastname"
								v-model="payway.lastname"
							/>
							<input
								type="hidden"
								name="phone"
								v-model="payway.phone"
							/>
							<input
								type="hidden"
								name="email"
								v-model="payway.email"
							/>
							<input
								type="hidden"
								name="return_params"
								v-model="payway.return_params"
							/>
							<input
								type="hidden"
								name="return_url"
								v-model="payway.return_url"
							/>
							<input
								type="hidden"
								name="continue_success_url"
								v-model="payway.continue_success_url"
							/>
							<input
								type="hidden"
								name="payment_option"
								v-model="payway.payment_option"
							/>
						</v-form>
						<iframe
							scrolling="yes"
							class="aba-iframe"
							src=""
							name="aba_webservice"
							id="aba_webservice"
							style="width: 100%; height: 100%; min-height: 500px"
							frameBorder="0"
						></iframe>
					</template>
					<template v-else>
						<v-layout row wrap fill-height class="text-center">
							<v-flex xs12>
								<h3>{{ $t("label.please_wait") }}</h3>
							</v-flex>
						</v-layout>
					</template>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import WalletPaymentMethodForm from "@Wallet/forms/WalletPaymentMethodForm.vue";
import { Link } from "@inertiajs/inertia-vue";
import Vue from "vue";
export default {
	components: {
		WalletPaymentMethodForm,
		Link,
	},
	props: ["coupon", "payment_methods"],

	data() {
		return {
			clicked: false,
			item: this.$inertia.form({
				coupon_id: this.coupon.id,
				payment_method_code: null,
				hash: null,
			}),
			dialog: false,
			payway: null,
		};
	},

	methods: {
		submit() {
			if (this.item.payment_method_code == "PAYWAY") {
				this.pay("cards");
			} else if (this.item.payment_method_code == "ABAPAY") {
				this.pay("abapay");
			} else {
				this.checkout();
			}
		},

		async pay(payment_option) {
			try {
				this.payway = null;
				const response = await axios.get(
					this.$route("payway.coupons.checkout", {
						coupon: this.coupon.uuid,
						payment_option: payment_option,
					})
				);
				if (response.data.success == true) {
					this.dialog = true;
					this.payway = response.data.data;
					this.item.hash = this.payway.hash;
					Vue.nextTick(() => {
						document
							.getElementById("aba_merchant_request")
							.submit();
					});
				}
			} catch (error) {
				this.$toast.error(error.message);
			}
		},

		async close() {
			await this.verifyPayment();
		},

		async verifyPayment() {
			try {
				this.$wait.start("verifying payment");
				const response = await axios.post(
					this.$route("payway.topups.verify", {
						hash: this.item.hash,
					})
				);
				if (response.data.success) {
					if (response.data.data) {
						this.checkout();
					} else {
						this.$toast.open("please complete payment to continue");
					}
					this.dialog = false;
				} else {
					this.$toast.error(response.data.data);
				}
			} catch (error) {
				this.$toast.error(error.message);
			} finally {
				this.$wait.end("verifying payment");
			}
		},

		checkout() {
			this.item.post(
				this.$route("wallet.topups.store", {
					coupon: this.coupon.uuid,
				})
			);
		},

		confirmLeave() {
			return window.confirm(
				"Do you really want to leave? you have unsaved changes!"
			);
		},

		confirmStayInDirtyForm() {
			return !this.confirmLeave();
		},

		beforeWindowUnload(e) {
			if (this.confirmStayInDirtyForm()) {
				e.preventDefault();
				e.returnValue = "";
			}
		},
	},

	created() {
		window.addEventListener("beforeunload", this.beforeWindowUnload);
	},

	beforeDestroy() {
		window.removeEventListener("beforeunload", this.beforeWindowUnload);
	},
};
</script>